import { render } from "./AnalogClockScreen.vue?vue&type=template&id=0423c690&scoped=true&ts=true"
import script from "./AnalogClockScreen.vue?vue&type=script&lang=ts"
export * from "./AnalogClockScreen.vue?vue&type=script&lang=ts"

import "./AnalogClockScreen.vue?vue&type=style&index=0&id=0423c690&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0423c690"]])

export default __exports__